<section class="tracker-panel">
  <div class="tracker-grid">
    <div class="panel-card panel-card--success" [class.panel-card--result-only]="isElectionClosed && !hasVoteReceipt">
      <span class="section-chip">{{ successChip }}</span>
      <h2 class="section-title">
        {{ successTitle }}
        <span *ngIf="!isElectionClosed || hasVoteReceipt" class="title-celebration" aria-hidden="true">🎉</span>
      </h2>
      <p class="section-description">
        {{ successDescription }}
      </p>

      <div *ngIf="hasVoteReceipt; else noVoteNotice" class="protocol-box">
        <span class="protocol-label">Protocolo da votação</span>
        <strong class="protocol-value">{{ trackingData.voteReceipt!.protocol }}</strong>
        <span class="protocol-date">Registrado em {{ trackingData.voteReceipt!.registeredAt | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>

      <ng-template #noVoteNotice>
        <div class="protocol-box protocol-box--neutral">
          <span class="protocol-label">Situação da participação</span>
          <strong class="protocol-value">Nenhum voto registrado nesta eleição</strong>
          <span class="protocol-date">Os resultados permanecem disponíveis apenas durante o período de consulta liberado pela empresa.</span>
        </div>
      </ng-template>
    </div>

    <aside class="panel-card panel-card--support panel-card--summary">
      <span class="section-chip">{{ summaryChip }}</span>
      <h3>{{ summaryTitle }}</h3>
      <p class="support-description">
        {{ summaryDescription }}
      </p>

      <div class="tracking-stat-list">
        <article class="tracking-stat-card">
          <span class="tracking-stat-label">Votos computados</span>
          <strong class="tracking-stat-value">{{ trackingData.totalVotes }}</strong>
        </article>
        <article class="tracking-stat-card">
          <span class="tracking-stat-label">Participação atual</span>
          <strong class="tracking-stat-value">{{ trackingData.turnoutPercentage | number:'1.0-1' }}%</strong>
        </article>
      </div>

      <div class="tracking-meta">
        <span>Última atualização em {{ trackingData.lastUpdatedAt | date:'dd/MM/yyyy HH:mm' }}</span>
        <span>{{ trackingPrivacyMessage }}</span>
      </div>
    </aside>
  </div>
</section>

<section
  *ngIf="votingData.election.status === 'encerrada' || votingData.election.status === 'homologada'"
  class="tracker-results"
>
  <div class="results-header">
    <div>
      <span class="section-chip">{{ resultsChip }}</span>
      <h2 class="section-title">{{ resultsTitle }}</h2>
      <p class="section-description">
        {{ resultsDescription }}
      </p>
    </div>
  </div>

  <app-candidate-grid
    [candidates]="trackedCandidates"
    [blankVotesCount]="trackingData.blankVotesCount"
    [blankVotesPercentage]="trackingData.blankVotesPercentage">
  </app-candidate-grid>
</section>
